import React, { useState } from 'react'

import { TtAvatar, TtButton, TtCard, TtIcon } from '@23/ui-react'

import { type WidgetDTO } from '../../../../../../model/Widget'
import { useSite } from '../../../../../../../sharedLegacy/context/SiteContext'
import { getAbsoluteUrl } from '../../../../../../../sharedLegacy/utils'
import { useVideoPreviewSettingsContext } from '../../../../VideoPreviewSettingsContext'

interface BusinessCardPreviewProps {
  widget: WidgetDTO
  isEditable: boolean
  handleEdit: () => void
  handleDelete: () => void
}

const BusinessCardPreview = ({
  widget,
  isEditable,
  handleEdit,
  handleDelete,
}: BusinessCardPreviewProps) => {
  const { site_url: siteUrl } = useSite()
  const avatarUrl = getAbsoluteUrl(widget.avatar, siteUrl)
  const { logoSrc } = useVideoPreviewSettingsContext()
  const [showActions, setShowActions] = useState(false)

  return (
    <div
      className="personal-widget-business-card-wrapper"
      onMouseEnter={() => isEditable && setShowActions(true)}
      onFocus={() => isEditable && setShowActions(true)}
      onMouseLeave={(e) => {
        const target = e.relatedTarget as Node | null
        if (!target || !e.currentTarget.contains(target)) {
          setShowActions(false)
        }
      }}
      onBlur={(e) => {
        const target = e.relatedTarget as Node | null
        if (!target || !e.currentTarget.contains(target)) {
          setShowActions(false)
        }
      }}
      //eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={isEditable ? 0 : undefined}
    >
      {isEditable && showActions && (
        <div className="personal-widget-business-card-actions">
          <TtButton
            color="secondary"
            variant="light"
            size="x-small"
            className="personal-widget-business-card-action personal-widget-business-card-action--delete"
            onClick={handleDelete}
            label="Delete"
          >
            <TtIcon library="one" name="bin" />
          </TtButton>
          <TtButton
            color="secondary"
            variant="light"
            size="x-small"
            className="personal-widget-business-card-action personal-widget-business-card-action--edit"
            onClick={handleEdit}
            label="Edit"
          >
            <TtIcon library="one" name="edit" />
          </TtButton>
        </div>
      )}
      <TtCard className="personal-widget-business-card" hideLabel>
        <div className="personal-widget-business-card-header">
          <div className="personal-widget-business-card-logo-left">
            {avatarUrl && (
              <TtAvatar
                label={widget.name}
                image={avatarUrl}
                size="xl"
                className="personal-widget-business-card-avatar"
              />
            )}
          </div>
          {logoSrc && (
            <div className="personal-widget-business-card-brand-right">
              <img
                src={logoSrc}
                alt="Site logo"
                className="personal-widget-business-card-logo"
              />
            </div>
          )}
        </div>
        <div className="personal-widget-business-card-content">
          <div className="personal-widget-business-card-name">
            {widget.name || 'Full Name'}
          </div>
          {widget.title && (
            <div className="personal-widget-business-card-title">
              {widget.title}
            </div>
          )}
          {widget.phone && (
            <div className="personal-widget-business-card-info">
              {widget.phone}
            </div>
          )}
          {widget.email && (
            <div className="personal-widget-business-card-info">
              {widget.email}
            </div>
          )}
        </div>
      </TtCard>
    </div>
  )
}

export { BusinessCardPreview }
